import { NARRATIVE_COMPANY_PRIMARY_VALUATION_FRAGMENT } from '@/components/NarrativeTable/components/TableRow/narrative-company-fragment';
import { gql } from '@/utilities/gql';

export const WATCHLIST_ITEM_FRAGMENT = gql(`
  fragment watchlistItemFields on WatchlistItem @_unmask {
    id
    createdAt
    companyId
    autoAdded
    company {
      id
      name
      tickerSymbol
      uniqueSymbol
      canonicalURL
      exchangeCountryISO
      info {
        url
      }
      secondaryIndustry {
        name
      }
      data {
        currencyInfo
      }
      score {
        value
        future
        past
        health
        dividend
        total
        sentence
      }
      analysisDividend {
        dividendYield
      }
      analysisFuture {
        forwardPe1Y
        forwardPriceToSales1Y
        revenueGrowthAnnual
        netIncomeGrowthAnnual
      }
      analysisHealth {
        netIncome
      }
      analysisValue {
        pe
        pb
        priceToSales
        preferredRelativeMultiple
        lastSharePrice
        npvPerShare
        marketCapUSD
        intrinsicDiscount
        return7d
        return30d
        return90d
        return1yAbs
        priceTarget
        priceTargetAnalystCount
      }
      analysisMisc {
        analystCount
      }
    }
  }
`);

export const WATCHLIST_FRAGMENT = gql(`
  fragment watchlistFields on Watchlist @_unmask {
    id
    name
    itemsLimit
    totalItems
  }
`);

export const WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT = gql(
  `
  fragment narrativeFairValueFields on WatchlistItem @_unmask {
    company {
      myValuation {
        id
        type
        narrative {
          id
          owner {
            displayName
            imageUrl
          }
          title
        }
      }
      defaultNarrative {
        id
        title
        valuation {
          id
          type
        }
        owner {
          displayName
          imageUrl
        }
      }
      ...NarrativeCompanyPrimaryValuationFields
    }
  }
`,
  [NARRATIVE_COMPANY_PRIMARY_VALUATION_FRAGMENT]
);
